import { render, staticRenderFns } from "./repru-auswahl-modal.vue?vue&type=template&id=2a4c24cc&scoped=true"
import script from "./repru-auswahl-modal.vue?vue&type=script&lang=js"
export * from "./repru-auswahl-modal.vue?vue&type=script&lang=js"
import style0 from "./repru-auswahl-modal.vue?vue&type=style&index=0&id=2a4c24cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c24cc",
  null
  
)

export default component.exports